import type { ICarouselItem } from "../../../../types/models/carousel.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  carouselItems: ICarouselItem[];
  pagination: IPagination;
}

export function useGetCarouselItemsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/carousel",
  });
}

interface IOrderResponse {
  carousel: import("../../../../types/models/carousel.models.types").ICarouselOrderedItem[];
}

export function useGetCarouselOrderAdminHttp() {
  return useGetHttp<IOrderResponse>({
    path: "/admin/carousel/order",
  });
}
